import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Image, Link, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import InfoSVG from '../../../assets/images/help-desk/info.svg';
import UserSVG from '../../../assets/images/help-desk/user.svg';

const HotelInfo = ({ hotelInfoResult, requestType }) => {

    return (

        <React.Fragment>

            {requestType.split(',')[4] === 'hotelInfoFinished' &&
                <React.Fragment>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start justify-content-end position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards'
                        }}>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-left-0`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-dark)'
                            }}>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                تایید و ارسال درخواست اطلاعات هتل
                            </Typography>
                        </Box>
                        <Box
                            className={`mx-xs ml-0 my-sm mb-0 rounded-circle`}>
                            <Image
                                src={UserSVG}
                                alt='info'
                                ms={{
                                    width: '18px',
                                    height: '18px'
                                }} />
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '0.5s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)',
                            }}>
                            {hotelInfoResult.CancelationRules !== '' && hotelInfoResult.CancelationRules &&
                                <Link
                                    className={`d-block text-primary`}
                                    href={`http://www.${hotelInfoResult.CancelationRules}`}
                                    target='_blank'>
                                    لینک قوانین کنسلی
                                </Link>
                            }
                            {hotelInfoResult.PublicRules !== '' && hotelInfoResult.PublicRules &&
                                <Link
                                    className={`d-block text-primary`}
                                    href={`http://www.${hotelInfoResult.PublicRules}`}
                                    target='_blank'>
                                    لینک قوانین عمومی
                                </Link>
                            }
                            {hotelInfoResult.Facilities !== '' && hotelInfoResult.Facilities &&
                                <Link
                                    className={`d-block text-primary`}
                                    href={`http://www.${hotelInfoResult.Facilities}`}
                                    target='_blank'>
                                    لینک اطلاعات و امکانات
                                </Link>
                            }
                            {hotelInfoResult.Tell !== '' && hotelInfoResult.Tell &&
                                <Typography
                                    className={`d-block`}>
                                    تلفن تماس : <span dir='ltr'>{hotelInfoResult.Tell}</span>
                                </Typography>
                            }
                            {hotelInfoResult.CheckInOutTime !== '' && hotelInfoResult.CheckInOutTime &&
                                <Box
                                    className={`d-flex`}>
                                    <Typography
                                        className={`d-block mx-lg mr-0`}>
                                        ساعت ورود : {hotelInfoResult.CheckInOutTime?.split('-')[0]}
                                    </Typography>
                                    <Typography
                                        className={`d-block`}>
                                        ساعت خروج : {hotelInfoResult.CheckInOutTime?.split('-')[1]}
                                    </Typography>
                                </Box>
                            }
                            {hotelInfoResult.Location !== '' && hotelInfoResult.Location &&
                                <Link
                                    className={`d-block text-primary`}
                                    href={`http://www.${hotelInfoResult.Location}`}
                                    target='_blank'>
                                    لینک لوکیشن
                                </Link>
                            }
                            {hotelInfoResult.Address !== '' && hotelInfoResult.Address &&
                                <Typography
                                    className={`d-block`}>
                                    نشانی : {hotelInfoResult.Address}
                                </Typography>
                            }
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '1s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)',
                            }}>
                            <Typography
                                className={`d-block`}>
                                اطلاعات درخواستی شما را طریق پیامک و ایمیل نیز ارسال می شود.
                            </Typography>
                        </Box>
                    </Box>
                </React.Fragment>
            }

        </React.Fragment>

    );

}

export default HotelInfo;